import {View} from 'MWC';
import tpl from '../../templates/mobile/main';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            headerMenu: 'main',
            isOpened: false
        };

        this.changeMenu = this.changeMenu.bind(this);
        this.toggle = this.toggle.bind(this);
        return this;
    }

    toggle = () => {
        this.setState(
            prevState => ({
                headerMenu: 'main',
                isOpened: !prevState.isOpened
            }),
            () => {
                this.state.isOpened ? this.removeScroll() : this.addScroll();
            }
        );
    };

    removeScroll() {
        document.body.classList.add('disable-scroll');
    }

    addScroll() {
        document.body.classList.remove('disable-scroll');
    }

    changeMenu = menuName => {
        this.setState({headerMenu: menuName});
    };

    static displayName = 'Header.Views.Mobile';
}
